import React from 'react';
import Box from '@amzn/meridian/box';
import Select, { SelectOption } from '@amzn/meridian/select';
import { CAPAnsweredQuestionItem, Question } from './formData.types';
import { useIntl } from 'react-intl';

interface RenderGenericDropdownsFromDataProps {
  selected: CAPAnsweredQuestionItem | undefined;
  question: Question;
  styles: any;
  onChange: (args: CAPAnsweredQuestionItem) => void;
  disabled?: boolean;
}

const RenderGenericDropdownsFromData: React.FC<
  RenderGenericDropdownsFromDataProps
> = ({ selected, question, styles, onChange, disabled = false }) => {
  const intl = useIntl();

  const handleChange = (value: any) => {
    onChange({
      checkedValue: value,
      numValue: value,
    });
  };

  return (
    <Box className={styles.dropdownItemContainerRightStepper}>
      <div></div>
      <div className={styles[`genericDropdownItem`]}>
        <Select
          label={intl.formatMessage({
            id: question.QUESTION_TEXT.TRANSLATION_ID,
            defaultMessage: question.QUESTION_TEXT.DEFAULT_MESSAGE,
          })}
          value={selected?.checkedValue}
          onChange={handleChange}
          error={false}
          disabled={disabled}
        >
          {question?.QUESTION_OPTIONS?.map(option =>
            option.DEFAULT_MESSAGE ? (
              <SelectOption
                key={option.VALUE}
                value={option.VALUE}
                label={intl.formatMessage({
                  id: option.TRANSLATION_ID ?? '',
                  defaultMessage: option.DEFAULT_MESSAGE ?? '',
                })}
              />
            ) : null
          )}
        </Select>
      </div>
    </Box>
  );
};

export default RenderGenericDropdownsFromData;
